import React, { useState } from 'react';
import FormContact from 'components/artectum/common/contact-form-artectum';
import 'react-modal-video/css/modal-video.min.css';
import ComprarSection from './ComprarSection';
import BaseModal from 'components/common/modal/BaseModal';
import { Modal, Button } from 'react-bootstrap';
import { useInitialFetch } from 'core/context/initialFetchContext';

const ProductInfo = ({ product, selectedOption, handleOptionChange, selectedSize, setSelectedSize, showRealLife, setShowRealLife, realLifeApplications, setCurrentImageIndex, scrollToTop }) => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const { storeInformation } = useInitialFetch();

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const whatsappMessage = `Hola, me interesa el producto *${product?.title}*.\n` +
        (selectedOption ? `Estoy considerando la opción: *${selectedOption.value}*.\n` : '') +
        (selectedSize ? `Tamaño: *${selectedSize.value}*.\n` : '') +
        `¿Podrías darme más información?\n` +
        `Puedes ver el producto aquí: ${window.location.href}`;

    return (
        <div className="modal-product-info p-0 ps-md-4">
            <ComprarSection
                product={product}
                selectedOption={selectedOption} 
                handleOptionChange={handleOptionChange}
                selectedSize={selectedSize}
                setSelectedSize={setSelectedSize}
            />
            <div className="ltn__product-details-menu-2 mt-4">
                <ul className="d-flex gap-2">
                    <li className="m-0">
                        <button className="theme-btn-4 btn" title="Obtener más información" onClick={() => setIsFormOpen(true)}>
                            <i className="fas fa-info-circle me-2" />
                            <span>Cotiza con Nosotros</span>
                        </button>
                    </li>
                    <li className="m-0">
                        <a target="_blank" href={`https://wa.me/${storeInformation?.whatsapp}?text=${encodeURIComponent(whatsappMessage)}`} className="theme-btn-wsp btn" title="Contactar por WhatsApp">
                            <i className="me-2 fab fa-whatsapp" />
                            <span>WHATSAPP</span>
                        </a>
                    </li>
                </ul>
            </div>

            <BaseModal
                show={isFormOpen}
                title="Obten más información de este producto"
                handleClose={() => setIsFormOpen(false)}
                handleSave={() => setIsFormOpen(false)}
                size="lg"
            >
                <FormContact product={product} selectedOption={selectedOption} selectedSize={selectedSize} handleCloseParentModal={() => setIsFormOpen(false)} setModalIsOpen={setModalIsOpen} />
            </BaseModal>

            <Modal show={modalIsOpen} size="lg" onHide={closeModal}>
                <Modal.Header className="p-4 pb-0" closeButton>
                    <Modal.Title>
                        <i className="fas fa-check-circle text-success me-2"></i>
                        Formulario enviado con éxito
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <div id='product-pro-forma'>
                        <p>Gracias por contactarnos. Nos pondremos en contacto con usted pronto.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ProductInfo;